import util from '@bmp-vue/core/api/util'

const controller = 'GradeHorario'
export default Object.assign({}, util.GetCrud(controller, null), {
    GetTipoGrade() {
        return util.Axios.GetAll(controller + '/Tipos')
      },
})
